import type { ISEOProps } from "../types/core";

export const AdminDashboardPageSEO: ISEOProps = {
  title: "Admin Dashboard - Sugar Cribs",
  description:
    "Administrative dashboard for Sugar Cribs platform management, analytics, and user oversight.",
};
